import React, { Component } from "react";
import { connect } from "react-redux";
import { ProgressBar, Spinner } from "react-bootstrap";
import "./styles.css";
import {
    setParseProgress,
    setParseFailureMessage,
    setUploadState,
} from "../actions";
import { uploadStates } from "../constants";
import { getParsingStatus } from "../helpers";
import {
    EMPTY_STRING,
    MAX_PARSING_STATUS_MISSES,
    SUCCESS,
    CANNOT_CONNECT_CACHE,
    clientErrorMessages,
} from "../../../constants";
import PropTypes from "prop-types";
import { addPendoTracking } from "../../../helpers/helpers";
import { trackingEventNames } from "../../../helpers/pendo_constants";

class UploadParseCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            missCount: 0,
            startTime: Date.now(),
        };

        this.updateParseProgress = this.updateParseProgress.bind(this);
    }

    componentDidMount() {
        let scope = this;
        let key;

        if (this.props.folderKey !== EMPTY_STRING) {
            key = scope.props.folderKey;
        } else if (this.props.fileKey !== EMPTY_STRING) {
            key = scope.props.fileKey;
        }

        this.pollProgress = setInterval(() => {
            // Check if 120 seconds have elapsed
            const elapsedTime = Date.now() - this.state.startTime;
            if (elapsedTime > 120000) {
                clearInterval(this.pollProgress);
                addPendoTracking(
                    trackingEventNames.PARSING_NEW_PATIENT,
                    this.props.planuuid,
                    "Parsing timeout: operation took too long",
                    {
                        label: this.props.label,
                        visituuid: this.props.visituuid,
                        patientuuid: this.props.patientuuid,
                    }
                );
                scope.props.setParseProgress(0);
                scope.props.setParseFailureMessage(
                    "Parsing timeout: operation took too long"
                );
                scope.props.setUploadState(uploadStates.FAILED);
                return;
            }

            getParsingStatus(key, this.props.authToken).then((response) => {
                if (response) {
                    scope.updateParseProgress(response);
                } else {
                    scope.props.setParseProgress(0);
                    scope.props.setParseFailureMessage(
                        clientErrorMessages.UNABLE_TO_REACH_SERVER
                    );
                    scope.props.setUploadState(uploadStates.FAILED);
                }
            });
        }, 1000);
    }

    updateParseProgress(response) {
        let scope = this;

        if (response.status === SUCCESS) {
            if (
                response.progress != null &&
                !isNaN(parseFloat(response.progress))
            ) {
                scope.props.setParseProgress(parseFloat(response.progress));
            } else {
                addPendoTracking(
                    trackingEventNames.PARSING_NEW_PATIENT,
                    this.props.planuuid,
                    clientErrorMessages.PARSING_GET_PROGRESS_FAILED,
                    {
                        label: this.props.label,
                        visituuid: this.props.visituuid,
                        patientuuid: this.props.patientuuid,
                    }
                );
                scope.props.setParseProgress(0);
                scope.props.setParseFailureMessage(
                    clientErrorMessages.PARSING_GET_PROGRESS_FAILED
                );
                scope.props.setUploadState(uploadStates.FAILED);
            }
        } else if (response.status === CANNOT_CONNECT_CACHE) {
            scope.props.setParseProgress(0);
            scope.setState({ missCount: scope.state.missCount + 1 });

            if (this.state.missCount === MAX_PARSING_STATUS_MISSES) {
                addPendoTracking(
                    trackingEventNames.PARSING_NEW_PATIENT,
                    this.props.planuuid,
                    clientErrorMessages.PARSING_START_FAILED,
                    {
                        label: this.props.label,
                        visituuid: this.props.visituuid,
                        patientuuid: this.props.patientuuid,
                    }
                );
                scope.props.setParseFailureMessage(
                    clientErrorMessages.PARSING_START_FAILED
                );
                scope.props.setUploadState(uploadStates.FAILED);
            }
        } else {
            scope.props.setParseProgress(0);
            scope.props.setParseFailureMessage(response.error);
            scope.props.setUploadState(uploadStates.FAILED);
        }
    }

    componentDidUpdate() {
        if (this.props.parseProgress >= 100) {
            clearInterval(this.pollProgress);
            this.props.setUploadState(uploadStates.COMPLETE);
        }
    }

    componentWillUnmount() {
        clearInterval(this.pollProgress);
    }

    render() {
        return (
            <div
                id={this.props.id}
                className={`upload-card progress solid`}
                style={this.props.style}
            >
                <div className={"finish-check-container"}>
                    <Spinner animation="grow" variant="primary" />
                </div>
                <div className={"upload-bar-container"}>
                    <div className={"upload-progress-bar"}>
                        <ProgressBar now={100} label={`Uploading Complete!`} />
                    </div>
                    <div className={"parse-progress-bar"}>
                        <ProgressBar
                            animated
                            now={this.props.parseProgress}
                            label={`Reading File... ${this.props.parseProgress}%`}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

UploadParseCard.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    parseProgress: PropTypes.string,
    setUploadState: PropTypes.func,
    style: PropTypes.object,
    folderKey: PropTypes.string,
    fileKey: PropTypes.string,
    authToken: PropTypes.string,
    planuuid: PropTypes.string,
    visituuid: PropTypes.string,
    patientuuid: PropTypes.string,
};

UploadParseCard.defaultProps = {
    id: EMPTY_STRING,
    label: EMPTY_STRING,
    parseProgress: "0",
    folderKey: EMPTY_STRING,
    fileKey: EMPTY_STRING,
    authToken: EMPTY_STRING,
    planuuid: EMPTY_STRING,
    visituuid: EMPTY_STRING,
    patientuuid: EMPTY_STRING,
};

/* istanbul ignore next */
const mapStateToProps = function (state, ownProps) {
    return {
        authToken: state.LoginReducer.authToken,
        parseProgress: state.CreatePlanReducer.parseProgress[ownProps.idx],
        planuuid: state.CreatePlanReducer.planuuid,
        visituuid: state.CreatePlanReducer.visituuid,
        patientuuid: state.CreatePlanReducer.patientuuid,
    };
};

/* istanbul ignore next */
const mapDispatchToProps = function (dispatch, ownProps) {
    return {
        setUploadState: (upstate) =>
            dispatch(setUploadState(ownProps.idx, upstate)),
        setParseProgress: (prog) =>
            dispatch(setParseProgress(ownProps.idx, prog)),
        setParseFailureMessage: (msg) =>
            dispatch(setParseFailureMessage(ownProps.idx, msg)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UploadParseCard);
